module.exports = __webpack_public_path__ + "static/img/case-glj-page-bg-01.bfd2b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/glj/case-glj-page-bg-01.png
// module id = qTU0
// module chunks = 1